import client from './apiClient';

function getLoginInfo({ environment, userName = '' }) {
  return client(
    `portalloginurl/${environment}?userName=${encodeURIComponent(userName)}`
  );
}

export { getLoginInfo };
